// export const BASE_URL = 'https://gasanalytics.igxindia.com/api';
export const BASE_URL = 'https://api-data.gna.energy';

export const APP_TOKEN = '259ba455-e622-45c6-8450-24bd5c574965	';
